import React, { useEffect } from 'react';
import { useGetPaymentInfo } from 'Core/hooks/platform/useGetPaymentInfo';
import Loader from 'Core/components/Loader';
import { useTranslation } from 'react-i18next';
import { platformPaths } from 'Core/config/platformConfig';
import { useNavigate } from 'react-location';

export function Platform() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: { purpose, provider, payment_option } = {} } = useGetPaymentInfo();

  useEffect(() => {
    // const to = platformPaths.FINANCING_FORTIVA;
    // navigate({ to, search: true });

    if (purpose) {
      let to = platformPaths[purpose];
      if (payment_option && payment_option.toUpperCase() === 'GLOBAL') {
        to = platformPaths.FINANCING_LENDFLOW;
      } else if (provider && provider.toLowerCase() === 'patientfi') {
        to = platformPaths.FINANCING_PATIENTFI;
      } else if (provider && provider.toLowerCase() === 'fortiva') {
        to = platformPaths.FINANCING_FORTIVA;
      }
      navigate({ to, search: true });
    }
  }, [navigate, purpose, provider, payment_option]);

  return <Loader message={t('status.loading')} />;
}
